// ui/landingPage/samplingEventsTab/actions.js

import { SAMPLING_EVENT_VIEWS } from "../../../../constants/samplingEventConstants";

export const makeSamplingEventsTabUIActions = (set, get) => ({
  setCurrentView: (view) =>
    set((s) => ({
      samplingEventsTabUI: { ...s.samplingEventsTabUI, currentView: view },
    })),
  setActiveTab: (tab) =>
    set((s) => ({
      samplingEventsTabUI: { ...s.samplingEventsTabUI, activeTab: tab },
    })),
  showTableView: () =>
    set((s) => ({
      samplingEventsTabUI: {
        ...s.samplingEventsTabUI,
        currentView: SAMPLING_EVENT_VIEWS.TABLE,
      },
    })),
  showCreateFormView: () =>
    set((s) => ({
      samplingEventsTabUI: {
        ...s.samplingEventsTabUI,
        currentView: SAMPLING_EVENT_VIEWS.CREATE_FORM,
      },
    })),
  showEventFormView: () =>
    set((s) => ({
      samplingEventsTabUI: {
        ...s.samplingEventsTabUI,
        currentView: SAMPLING_EVENT_VIEWS.EVENT_FORM,
      },
    })),
  showWellUploadsView: () =>
    set((s) => ({
      samplingEventsTabUI: {
        ...s.samplingEventsTabUI,
        currentView: SAMPLING_EVENT_VIEWS.WELL_UPLOADS,
      },
    })),
});
